<template>
    <div class="upload-wrapper">
        <i class="fas fa-times align-self-end close" @click="close()"></i>
        <PatientDocuments
            ref="patientDocuments"
            :title="options.title"
            :patient-id="options.patientId"
            :upload-document="uploadDocument"
            :delete-document="deleteDocument"
            :get-documents="getPatientDocuments"
            :is-edit-patient="!!options.isEditPatient"
            :providerId="options.providerId"
            :application="options.application"
            :accountId="options.accountId"
        >
            <template #document-filters>
                <div>
                    <div class="form-group form-inline d-flex mt-2 mb-2">
                        <label class="me-2 mt-1">Admission Period:</label>
                        <select name="admission-period" class="form-select w-10" v-model="selectedPatientVersionId">
                            <option :value="emptyGuid">All</option>
                            <option
                                v-for="admissionPeriod of admissionPeriods"
                                :value="admissionPeriod.patientVersionId"
                            >
                                {{ getAdmissionPeriodLabel(admissionPeriod) }}
                            </option>
                        </select>
                    </div>
                </div>
            </template>
        </PatientDocuments>
    </div>
</template>

<style src="./Upload.scss" />
<script lang="ts" src="./Upload.ts" />
